import gql from 'graphql-tag';

const DriverAcceptSmsTerms = gql(/* GraphQL */ `
  mutation DriverAcceptSmsTerms($input: DriverAcceptSmsTermsInput!) {
    driverAcceptSmsTerms(input: $input) {
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default DriverAcceptSmsTerms;
